import { render, staticRenderFns } from "./dog-purchase-details.vue?vue&type=template&id=8d7d8cf2&scoped=true&lang=pug"
import script from "./dog-purchase-details.js?vue&type=script&lang=js&external"
export * from "./dog-purchase-details.js?vue&type=script&lang=js&external"
import style0 from "./dog-purchase-details.vue?vue&type=style&index=0&id=8d7d8cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d8cf2",
  null
  
)

export default component.exports